import { createSlice } from "@reduxjs/toolkit";

const chatRoleSlice = createSlice({
  name: "chatRole",
  initialState: {
    role: "customer",
  },
  reducers: {
    setNewChatRole: (state, action) => {
      state.role = action.payload;
    },
  },
});

export const { setNewChatRole } = chatRoleSlice.actions;
export default chatRoleSlice.reducer;
